export const ACTION_TYPES = {
    FETCH_START: "FETCH_START",
    FETCH_SUCCESS: "FETCH_SUCCESS",
    FETCH_ERROR: "FETCH_ERROR",
    FETCH_SUCCESS_LOAD: "FETCH_SUCCESS_LOAD",
    FETCH_START_LOAD_MORE: "FETCH_START_LOAD_MORE",
  };